import { render, staticRenderFns } from "./LandingHomeFR.vue?vue&type=template&id=0567063c&scoped=true"
import script from "./LandingHomeFR.vue?vue&type=script&lang=js"
export * from "./LandingHomeFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567063c",
  null
  
)

export default component.exports